import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import useUpdateQueryItem from '../../../services/api/hooks/useUpdateQueryItem'
import { updateDimension } from '../service/dimensionService'
import { Dimension } from '../types/Dimension'
import { getDimensionOptions } from './getDimensionOptions'

export const useUpdateDimension = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const options = getDimensionOptions(companyId)
  const { notification } = App.useApp()
  const updateQueryItem = useUpdateQueryItem()

  if (!companyId) {
    throw new Error('Company ID is required for dimensions.')
  }

  return useMutation({
    mutationKey: ['budget', 'dimension', 'update'],
    mutationFn: (data: Dimension) => updateDimension(data, companyId),
    onSuccess() {
      updateQueryItem([options])
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
